// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mubu","colBig":"styles_colBig__20-bd","colSmall":"styles_colSmall__3HUcp"};